import React from 'react';
import PropTypes from 'prop-types';
import SlashScreen from '../../components/SplashScreen';
import useAuth from '../../hooks/useAuth';

const SiteLayout = ({ children }) => {
    const { isAuthenticated, user } = useAuth();

    if (isAuthenticated && !!user) {
        return <SlashScreen />;
    }
    return (
        <main>
            {children}
        </main>
    );
};

SiteLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default SiteLayout;
